import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";
import { Subject } from "rxjs";

import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { CHANNEL_ORDER_XFER_SERVICE, IOrderXferService } from "../IOrderXferService";
import { OrderXferPromiseService } from "./OrderXferPromiseService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderXferPrimaryService extends OrderXferPromiseService {
  protected broker: ServiceMessageBroker;

  constructor(private worker: CubiqWorker, protected factory: ServiceMessageBrokerFactory) {
    super();

    this.broker = factory.createMessageBroker(CHANNEL_ORDER_XFER_SERVICE, true, true);

    this.broker.registerMethod(
      "requestXfer",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.requestXfer.bind(this),
      PRIMITIVE,
    );
  }

  public requestXfer(
    ids: Array<string>,
    comment: string,
    xferAction: CubiqTS.XferAction,
    targetGroupId: string,
    benchmarkXfer: boolean = false,
  ): Promise<boolean> {
    let request = new CubiqTS.OrderTransferRequestImpl();
    request.orderIds = ids;
    request.comment = comment;
    request.xferAction = xferAction;
    request.benchmarkXfer = benchmarkXfer;

    try {
      request.targetGroupID = CubiqTS.Long.fromString(targetGroupId);
    } catch (e) {
      logger.out.error(
        `${this.constructor.name}.requestXfer() ignoring request invalid targetGroupId: ids:${ids} comment:${comment} action:${CubiqTS.XferAction[xferAction]} targetGroupId:${targetGroupId} `,
      );
      logger.out.error(`${new Error().stack}`);

      request.targetGroupID = null;
    }

    return this.worker.postServiceRequest(request) as Promise<boolean>;
  }
}
